module.exports = __webpack_public_path__ + "img/no-data-img.b0031165.svg";